import React, { useEffect, useState } from "react";
import Classes from "./styles/style.module.css";
import AnimatedPageContainer from "../../../assets/containers/AnimatedPageContainer";
import IslansImg from "../../../assets/images/lig/IslandMap.png";
import WaveImage from "../../../assets/images/lig/wave.png";
import ShipImage from "../../../assets/images/lig/ship.png";
import AnchorImage from "../../../assets/images/lig/anchor.png";
import { useNavigate } from "react-router";
import { FaFlagCheckered } from "react-icons/fa";
import CustomHint from "../../../assets/containers/CustomHint";
import FinalStepPopUp from "./FinalStepPopUp";
import LigStepElement from "./LigStepElement";

const mapSteps = [
  { stepNum: 1, className: Classes.first },
  { stepNum: 2, className: Classes.second },
  { stepNum: 3, className: Classes.third },
  { stepNum: 4, className: Classes.forth },
  { stepNum: 5, className: Classes.fifth },
  { stepNum: 6, className: Classes.sixth },
  { stepNum: 7, className: Classes.seventh },
  { stepNum: 8, className: Classes.eigth },
  { stepNum: 9, className: Classes.ninth },
  { stepNum: 10, className: Classes.tenth },
  { stepNum: 11, className: Classes.eleventh },
  { stepNum: 12, className: Classes.twelveth },
];

const LigMap = () => {
  useEffect(() => {
    document.body.classList.add("mapBg");
    return () => {
      document.body.classList.remove("mapBg");
    };
  }, []);
  const [loaded, setLoaded] = useState(false);
  const [openFinalStepDialog, setOpenFinalStepDialog] = useState(false);
  const navigate = useNavigate();

  const stepClickHandler = (stepNum) => {
    if (stepNum !== 12) {
      navigate(`/lig/challenges/${stepNum}`);
    } else {
      setOpenFinalStepDialog(true);
    }
  };

  let stepIndicators = mapSteps.map((step) => {
    return (
      <LigStepElement
        clickHandler={() => stepClickHandler(step.stepNum)}
        currentStep={step.stepNum}
        className={step.className}
        key={step.stepNum}
      />
    );
  });

  return (
    <AnimatedPageContainer>
      <div className={Classes.mapMainContainer}>
        <div className="customContainer pt-4">
          <CustomHint hint={"جهت شروع روی نقطه‌ی قرمز کلیک کنید"} />
        </div>
        <div className={Classes.mapContainer}>
          <img
            src={IslansImg}
            alt="Island-map"
            className={Classes.islandMap}
            onLoad={() => setLoaded(true)}
          />
          <img src={WaveImage} alt="wave" className={Classes.waveImage} />
          {loaded && (
            <>
              <img src={ShipImage} alt="ship" className={Classes.Ship} />
              <img src={AnchorImage} alt="anchor" className={Classes.anchor} />
              {stepIndicators}
              <div
                className={Classes.firstStep}
                onClick={() => setOpenFinalStepDialog(true)}
              >
                <FaFlagCheckered />
              </div>
              <div className={Classes.animationContainer}></div>
            </>
          )}
        </div>
      </div>
      <FinalStepPopUp
        show={openFinalStepDialog}
        closeHander={() => setOpenFinalStepDialog(false)}
      />
    </AnimatedPageContainer>
  );
};

export default LigMap;
